import { add } from "date-fns";

export const DATE_MASK = "MM/dd/yyyy";

export const DEFAULT_DATE_QUICK_OPTIONS = [
  "+1",
  "+2",
  "+3",
  "+5",
  "+7",
  "+14",
  "+30"
];

export const defaultOnQuickOptionClick = (value: string) => {
  const days = parseInt(value.replace("+", ""));
  if (!days) return null;
  return add(new Date(), { days });
};

export const WARRANTY_QUICK_OPTIONS = ["+1yr", "+2yr", "+3yr", "+4yr", "+5yr"];
export const SERVICE_PLAN_QUICK_OPTIONS = [
  "+45d",
  "+1yr",
  "+2yr",
  "+3yr",
  "+4yr",
  "+5yr"
];
export const TRIAL_PERIOD_QUICK_OPTIONS = [
  "+30d",
  "+45d",
  "+60d",
  "+90d",
  "+6mo",
  "+1yr"
];

export const warrantyQuickOptionHandler = (
  value: string,
  anchorDate?: Date | null,
  baseDate?: Date | null
): Date | null => {
  const startDate = anchorDate ?? baseDate ?? new Date();
  const num = parseInt(value.replace("+", ""));
  if (!num) return null;

  if (value.endsWith("yr")) return add(startDate, { years: num });
  if (value.endsWith("mo")) return add(startDate, { months: num });
  if (value.endsWith("d")) return add(startDate, { days: num });
  return null;
};
